<template>
  <section class="conferenceCard-container">
    <img v-if="!showVideoPreview" class="conferenceCard-image" :style="imageStyle" :src="conferenceCard.image" />
    <div class="conferenceCard-details" :style="conferenceCardDetailsStyle">
      <div class="conferenceCard-name-and-onair">
        <div class="conferenceCard-name" v-html="conferenceCard.role"></div>
      </div>
      <p class="conferenceCard-description" :style="descriptionStyle" v-html="conferenceCard.description"></p>
    </div>
    <div :key="actionKey" class="conferenceCard-action" :class="{ 'conferenceCard-noURL': !conferenceCard.enableAction }" v-show="cardLoaded">
      <div :class="{ 'conferenceCard-button-enabled': conferenceCard.enableAction, 'conferenceCard-button-disabled': !conferenceCard.enableAction }" @click="action" v-if="isLive(activityData)">{{ conferenceCard.action }}</div>

      <div class="conferenceCard-button-disabled" @click="apiPostSchedule(conferenceCard)" v-if="!isLive(activityData) && isNew">
        <div>
          <i class="fas fa-calendar-plus" style="margin-right: 10px" v-if="!playProfileNotification"></i>
          <span v-if="!playProfileNotification">
            {{ new Date(activityData.date_start).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) }} - {{ new Date(activityData.date_start).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) }}
          </span>
          <SpinnerButton style="" v-if="playProfileNotification" />
        </div>
      </div>
      <div class="conferenceCard-button-disabled" style="" v-if="!isLive(activityData) && !isNew" @click="goToPersonalSchedule">
        <i class="fas fa-calendar-check" style="margin-right: 10px"></i>
        {{ new Date(activityData.date_start).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) }} - {{ new Date(activityData.date_start).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) }}
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/services/api.js';
import SpinnerButton from '@/components/ui/SpinnerButton.vue';

export default {
  name: 'ConferenceCard',
  components: { SpinnerButton },

  props: {
    conferenceCard: {},
    imageStyle: {},
    conferenceCardDetailsStyle: {},
    roleStyle: {},
    descriptionStyle: {},
  },
  data() {
    return {
      activityData: { property: { stream: '' } },
      showVideoPreview: false,
      isNew: true,
      userProfile: null,
      playProfileNotification: false,
      updaterInterval: null,
      actionKey: '',
      cardLoaded: false,
    };
  },
  beforeMount() {
    this.actionKey = this.$RNG.randomID();
    this.userProfile = this.$store.state.template.userProfile;

    this.loadCardActivity();
  },
  mounted() {
    this.updaterInterval = setInterval(() => {
      this.actionKey = this.$RNG.randomID();
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.updaterInterval);
  },
  methods: {
    loadCardActivity() {
      this.activityData = { ...this.activityData, ...this.conferenceCard.activity };
      this.cardLoaded = true;
    },
    action() {
      const act = this.conferenceCard.actionType;
      if (act == 'router') {
        if (this.conferenceCard.url === 'Explorer') {
          console.log('Navigating to Explorer with stream:', this.conferenceCard.target, 'and panel:', this.conferenceCard.panel);
          let panel = this.conferenceCard.panel;
          this.$router.push({
            name: 'Explorer',
            params: { stream: this.conferenceCard.target },
            query: { panel: panel },
          });
        } else {
          this.$router
            .push({
              name: this.conferenceCard.url,
              params: {
                stream: this.conferenceCard.target,
              },
            })
            .catch((err) => {
              console.error('navigation error', err);
            });
        }
      } else if (act == 'conference') {
        if (typeof this.activityData.property.meetLink === 'string' && this.activityData.property.meetLink.startsWith('{')) {
          try {
            if (this.activityData.property.openLinkInNewTab) {
              const obj = JSON.parse(this.activityData.property.meetLink);
              let routeData = this.$router.resolve({ name: obj.name, params: { stream: obj.params.stream } });
              window.open(routeData.href, '_blank');
            } else this.$router.push(JSON.parse(this.activityData.property.meetLink));
          } catch (err) {
            console.error(err);
          }
        } else if (this.$store.state.template.useZoomIntegration && this.conferenceCard.url.includes('zoom')) this.$router.push({ name: 'Conference', params: { stream: this.activityData.activity_id } });
        else window.open(this.activityData.property.meetLink);
      } else if (act == 'card-router') {
        if (typeof this.activityData.property.meetLink == 'string' && this.activityData.property.meetLink.startsWith('http')) {
          if (this.activityData.property.openLinkInNewTab) window.open(this.activityData.property.meetLink, '_blank');
          else window.open(this.activityData.property.meetLink, '_parent');
        } else {
          try {
            const route = JSON.parse(this.activityData.property.meetLink);
            if (this.activityData.property.openLinkInNewTab) {
              let routeData = this.$router.resolve({ name: route.name, params: route.name === 'Schedule' ? { date_start: route.params.date_start ?? null } : { stream: route.params.stream } });
              window.open(routeData.href, '_blank');
            } else {
              this.$router
                .push({
                  name: route.name,
                  params: route.name === 'Schedule' ? { date_start: route.params.date_start ?? null } : { stream: route.params.stream },
                })
                .catch((err) => {
                  console.error('navigation error', err);
                });
            }
          } catch (err) {
            console.error('navigation error', err);
          }
        }
      } else if (act == 'link') {
        window.open(this.conferenceCard.url, this.conferenceCard.target);
      } else if (act == 'inscript') {
        api
          .post(`activity/${this.conferenceCard.target}/inscript`)
          .then((response) => {
            if (response.data) {
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (act == 'talk') {
        api
          .post(`event/${this.$store.state.eventId}/createTalkChannel`, { user_id: this.conferenceCard.target, channelName: this.conferenceCard.url })
          .then((response) => {
            if (response.data) {
              this.$router
                .push({
                  name: 'Messages',
                  params: {
                    channelId: response.data.talk_channel_id,
                  },
                })
                .catch((err) => {
                  console.error('navigation error', err);
                });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (act == 'none') {
      } else {
      }
      this.$emit('finished');
      api.post(`sessionAction/`, {
        action: 'Card Action',
        properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, card: this.conferenceCard }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
    },
    videoPreview() {
      api
        .get(`event/${this.$store.state.eventId}/activities`)
        .then((response) => {
          this.conferenceCard;
          response.data.map((activity) => {
            if (activity.activity_id === this.conferenceCard.target && activity.activity_type == 'Live') {
              let parsed = JSON.parse(activity.property);
              this.conferenceCard.image = `${parsed.srcVideo}&autoplay=1&muted=1`;
              this.showVideoPreview = true;
            }
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    isLive(item) {
      if (item.date_start) {
        let startDate = new Date(item.date_start);
        let finishDate = new Date(item.date_finish);
        let today = new Date();

        return Date.parse(startDate) < Date.parse(today) && Date.parse(finishDate) > Date.parse(today);
      } else return true;
    },
    apiGetSchedule(isReload) {
      api
        .get(`event/${this.$store.state.eventId}/schedule?user_id=${this.$store.state.user.id}`)
        .then((response) => {
          let resp = response.data;
          let filtered = resp.filter((schedule) => {
            return schedule.activity_id == this.activityData.activity_id;
          });
          this.isNew = filtered.length == 0;

          this.$nextTick(() => {
            this.cardLoaded = true;
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    apiPostSchedule(item) {
      this.playProfileNotification = false;
      this.$emit('playProfileNotification', this.playProfileNotification);

      let payload = {
        event_id: this.$store.state.eventId,
        user_id: this.$store.state.user.id,
        activity_id: this.activityData.activity_id,
        start_date: new Date(this.activityData.date_start),
        finish_date: new Date(this.activityData.date_finish),
        title: this.activityData.description_short,
        description: this.activityData.description,
        notes: '',
        config: JSON.stringify({ group: this.activityData.trail ? this.activityData.trail : this.activityData.category, image: item.image, class: 'card', draggable: true }),
        links: item.target ? item.target : '',
        guests: JSON.stringify([]),
        organizer: this.$store.state.user.id,
        status: 'Confirmado',
        confirm: JSON.stringify(false),
        public: JSON.stringify(false),
      };

      api
        .get(`event/${this.$store.state.eventId}/schedule`)
        .then((response) => {
          let isNew = response.data.filter((schedule) => schedule.activity_id == payload.activity_id).length == 0;

          if (isNew) {
            api
              .post(`event/${this.$store.state.eventId}/schedule/`, payload)
              .then((response) => {
                this.playProfileNotification = true;
                this.$emit('playProfileNotification', this.playProfileNotification);

                setTimeout(() => {
                  this.playProfileNotification = false;

                  this.$emit('playProfileNotification', this.playProfileNotification);
                }, 3000);

                this.loadCardActivity();
              })
              .catch((err) => {
                this.playProfileNotification = false;
                this.$emit('playProfileNotification', this.playProfileNotification);
                console.error(err);
              });
          } else return;
        })
        .catch((err) => console.error(err));
    },
    goToPersonalSchedule() {
      this.$router.push({ name: 'PersonalSchedule' });
    },
  },
};
</script>

<style lang="scss">
.conferenceCard-container {
  position: relative;
  width: 300px;
  margin: 1%;
  justify-self: flex-start;
  background-color: var(--card-bgColor);
  border-radius: var(--card-borderRadius);
  box-shadow: 4px 10px 16px 0 rgba(0, 0, 0, 0.2);

  display: flex;
  flex-direction: column;

  @include media('<=phone') {
    width: 94%;
    margin: 3% 0;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      transform: scale(1.013);
      transition: 0.3s;
    }
  }
}
.conferenceCard-image {
  position: relative;
  display: block;
  height: 160px;
  width: 100%;
  object-fit: cover;
  object-position: center;
  border-top-left-radius: var(--card-borderRadius);
  border-top-right-radius: var(--card-borderRadius);
}

.conferenceCard-details {
  position: relative;
  padding: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.conferenceCard-name-and-onair {
  position: relative;
  display: flex;
  height: auto;
}
.conferenceCard-onair {
  position: absolute;
  width: 100%;
  height: 168px;
  color: var(--card-buttonTextColor);
  background-color: var(--card-buttonBgColor);
  border-top-right-radius: var(--card-borderRadius);
  border-top-left-radius: var(--card-borderRadius);
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 70px;
  font-weight: bolder;
}
.conferenceCard-name {
  position: relative;
  font-size: var(--card-titleFontSize);
  color: var(--card-titleColor);
  font-weight: 700;
  margin-bottom: 4px;
  width: 100%;
}
.conferenceCard-role {
  position: relative;
  display: inline-block;
  font-size: var(--card-roleFontSize);
  font-weight: 700;
  color: var(--card-subColor);
  padding: 0 0 0.3rem 0;
}
.conferenceCard-description {
  position: relative;
  color: var(--card-textColor);
  font-size: var(--card-descriptionFontSize);
  max-height: 200px;
  margin: 1.3% 0% 3% 0;
  overflow-y: auto;
  word-wrap: break-word;

  &::-webkit-scrollbar {
    background-color: transparent;
    width: 0px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--card-scrollbarBgColor);
    border-radius: var(--card-scrollbarBorderRadius);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--card-scrollbarHandleColor) !important;
    border-radius: var(--card-scrollbarBorderRadius);
    background-image: none !important;
  }
}

.conferenceCard-action {
  position: relative;
  bottom: 0;
  cursor: pointer;
  font-size: var(--card-buttonFontSize);
  height: 40px;
  width: 100%;
  text-align: center;
  z-index: 1;
  margin-bottom: 10px;
  background-color: transparent;
}
.conferenceCard-button-enabled {
  position: relative;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bolder;
  position: relative;
  color: var(--card-buttonTextColor);
  background-color: var(--card-buttonBgColor);
  border: 1px solid var(--card-buttonOutlineColor);
  border-radius: var(--card-buttonBorderRadius);
  margin: 0 10px;
}
.conferenceCard-button-disabled {
  position: relative;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bolder;
  position: relative;
  background-color: transparent;
  color: var(--card-buttonBgColor);
  border: 1px solid var(--card-buttonBgColor);
  border-radius: var(--card-buttonBorderRadius);
  margin: 0 10px;
}
.conferenceCard-noURL {
  position: relative;
  cursor: auto;
  pointer-events: none;
}
</style>
